export const listStyle = {
  alignItems: "center",
  bg: "white",
  borderRadius: 4,
  mb: 1,
  px: 4,
  py: 3,
};

export const listEmailStyle = {
  fontFamily: "heading",
  fontSize: 2,
  fontWeight: "bold",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: 250,
};

export const listDateStyle = {
  color: "textSecondary",
  fontSize: 1,
  fontWeight: "600",
  width: 300,
};

export const listActionStyle = {
  ":hover": {
    textDecoration: "underline",
  },
  color: "primary",
  cursor: "pointer",
  mx: 2,
  width: 150,
};

export const listActionsStyle = {
  marginLeft: "auto",
};

export const listAdminStyle = {
  cursor: "pointer",
  mr: 4,
  width: 200,
};
